
// import axios from 'axios';
// import React, { useEffect, useState, useRef } from 'react';
// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';
// import { useNavigate } from 'react-router-dom';
// import { FaEye, FaEdit, FaTrash } from 'react-icons/fa';

// const SalesOrderList = () => {
//     const [salesOrders, setSalesOrders] = useState([]);
//     const [selectedOrder, setSelectedOrder] = useState(null);
//     const [currentPage, setCurrentPage] = useState(1);
//     const ordersPerPage = 10;
//     const orderRef = useRef();
//     const navigate = useNavigate();

//     // ✅ Get logged-in user info
//     const storedUser = JSON.parse(sessionStorage.getItem("userData"));
//     const loggedInUserId = storedUser?.id;
//     console.log("Logged User:", storedUser);

//     useEffect(() => {
//         fetchOrders();
//     }, []);

//     const fetchOrders = async () => {
//         try {
//             const res = await axios.get("https://cloudapi.emedhatechnologies.com/pages/api/api/sales-orders");
//             const filteredOrders = res.data
//                 .map(order => ({ ...order, items: typeof order.items === "string" ? JSON.parse(order.items || "[]") : order.items || [], }))
//                 .filter(order => String(order.user_id) === String(loggedInUserId));
//             setSalesOrders(filteredOrders);
//         } catch (err) {
//             console.error("Error fetching sales orders:", err);
//             alert("Failed to load sales orders");
//         }
//     };
                                                 
//     const handlePrintPDF = async () => {
//         if (!orderRef.current) return;
//         const canvas = await html2canvas(orderRef.current, { scale: 2 });
//         const imgData = canvas.toDataURL("image/png");
//         const pdf = new jsPDF("p", "mm", "a4");
//         const width = pdf.internal.pageSize.getWidth();
//         const height = (canvas.height * width) / canvas.width;
//         pdf.addImage(imgData, "PNG", 0, 0, width, height);
//         pdf.save(`SalesOrder_${selectedOrder.order_number}.pdf`);
//     };

//     const handleEditOrder = (orderId) => navigate(`/dashboard/orders/edit/${orderId}`);

//     const handleDeleteOrder = async (orderId) => {
//         if (!window.confirm("Are you sure you want to delete this order?")) return;
//         try {
//             await axios.delete(`https://cloudapi.emedhatechnologies.com/pages/api/api/sales-orders/${orderId}`);
//             alert("🗑️ Order deleted successfully!");
//             fetchOrders();
//         } catch (err) {
//             console.error("Error deleting order:", err);
//             alert("❌ Failed to delete order");
//         }
//     };

//     // Pagination logic
//     const indexOfLastOrder = currentPage * ordersPerPage;
//     const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
//     const currentOrders = salesOrders.slice(indexOfFirstOrder, indexOfLastOrder);
//     const totalPages = Math.ceil(salesOrders.length / ordersPerPage);

//     return (
//         <div style={{  minHeight: '100vh', overflowX: "auto", width: "100%" }}>
//             <h4 style={{ fontSize: '15px', fontWeight: 'bold', textAlign: 'center', marginBottom: '10px' }}>📋 My Sales Orders</h4>

//             <div style={{ background: '#fff', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)', marginBottom: '25px' }}>
//                 <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                     <thead>
//                         <tr style={{ background: '#f5f5f5' }}>
//                             {['Order #', 'Customer', 'Order Date', 'Total Amount', 'Actions'].map((th, i) => (
//                                 <th key={i} style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}>{th}</th>
//                             ))}
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {currentOrders.length > 0 ? currentOrders.map(order => {
//                             const total = order.items.reduce((sum, it) => sum + (it.quantity * it.unit_price), 0);
//                             return (
//                                 <tr key={order.id}>
//                                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee' }}>{order.order_number}</td>
//                                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee' }}>{order.customer_name}</td>
//                                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee' }}>{new Date(order.order_date).toLocaleDateString()}</td>
//                                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee' }}>₹{total.toFixed(2)}</td>
//                                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', display: 'flex', gap: '10px' }}>
//                                         <FaEye title="View Order" style={{ color: '#007bff', cursor: 'pointer' }} onClick={() => setSelectedOrder(order)} />
//                                         <FaEdit title="Edit Order" style={{ color: '#28a745', cursor: 'pointer' }} onClick={() => handleEditOrder(order.id)} />
//                                         <FaTrash title="Delete Order" style={{ color: '#dc3545', cursor: 'pointer' }} onClick={() => handleDeleteOrder(order.id)} />
//                                     </td>
//                                 </tr>
//                             )
//                         }) : (
//                             <tr><td colSpan="6" style={{ textAlign: 'center', padding: '12px' }}>No sales orders found for this user</td></tr>
//                         )}
//                     </tbody>
//                 </table>
//                 <div style={{ textAlign: 'center', marginTop: '15px' }}>
//                     <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} style={{ margin: '0 5px', padding: '6px 12px', border: '1px solid #007bff', borderRadius: '4px', backgroundColor: currentPage > 1 ? '#007bff' : '#e0e0e0', color: currentPage > 1 ? '#fff' : '#888', cursor: currentPage > 1 ? 'pointer' : 'not-allowed' }}>Previous</button>
//                     <span style={{ margin: '0 8px', fontSize: '12px' }}>Page {currentPage} of {totalPages || 1}</span>
//                     <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages || totalPages === 0} style={{ margin: '0 5px', padding: '6px 12px', border: '1px solid #007bff', borderRadius: '4px', backgroundColor: currentPage < totalPages ? '#007bff' : '#e0e0e0', color: currentPage < totalPages ? '#fff' : '#888', cursor: currentPage < totalPages ? 'pointer' : 'not-allowed' }}>Next</button>
//                 </div>
//             </div>

//             {selectedOrder && (
//                 <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
//                     <div ref={orderRef} style={{ background: '#fff', padding: '25px 30px', borderRadius: '10px', width: '750px', maxHeight: '90vh', overflowY: 'auto' }}>
//                         <h3 style={{ textAlign: 'center', borderBottom: '2px solid #007bff', paddingBottom: '12px', marginBottom: '25px', fontSize: '20px' }}>
//                             🧾 Order #{selectedOrder.order_number}
//                         </h3>

//                         {/* Order Info */}
//                         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: '10px', marginBottom: '20px' }}>
//                             <div style={{ background: '#f1f1f1', padding: '8px', borderRadius: '5px' }}><strong>Customer:</strong> {selectedOrder.customer_name}</div>
//                             <div style={{ background: '#f1f1f1', padding: '8px', borderRadius: '5px' }}><strong>Order Date:</strong> {new Date(selectedOrder.order_date).toLocaleDateString()}</div>
//                             <div style={{ background: '#f1f1f1', padding: '8px', borderRadius: '5px' }}><strong>GST:</strong> {selectedOrder.gst}</div>
//                             <div style={{ background: '#f1f1f1', padding: '8px', borderRadius: '5px' }}><strong>GST Amount:</strong> ₹{selectedOrder.gst_amount?.toFixed(2) || 0}</div>
//                             <div style={{ background: '#f1f1f1', padding: '8px', borderRadius: '5px' }}><strong>Discount:</strong> ₹{selectedOrder.discount?.toFixed(2) || 0}</div>
//                             <div style={{ background: '#f1f1f1', padding: '8px', borderRadius: '5px' }}><strong>Total Amount:</strong> ₹{selectedOrder.total_amount?.toFixed(2) || 0}</div>
//                         </div>

//                         {/* Shipping & Notes */}
//                         <div style={{ marginBottom: '20px' }}>
//                             <div style={{ background: '#f1f1f1', padding: '8px', borderRadius: '5px', marginBottom: '8px' }}><strong>Shipping Address:</strong> {selectedOrder.shipping_address || 'N/A'}</div>
//                             <div style={{ background: '#f1f1f1', padding: '8px', borderRadius: '5px' }}><strong>Notes:</strong> {selectedOrder.notes || 'N/A'}</div>
//                         </div>

//                         {/* Items Table */}
//                         <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
//                             <thead>
//                                 <tr style={{ background: '#f5f5f5' }}>
//                                     {['Product', 'Thickness', 'Grade', 'Size', 'Qty', 'Unit Price', 'Total'].map((th, i) => (
//                                         <th key={i} style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left', fontSize: '14px' }}>{th}</th>
//                                     ))}
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {selectedOrder.items.map((item, idx) => (
//                                     <tr key={idx}>
//                                         <td style={{ padding: '6px', borderBottom: '1px solid #eee' }}>{item.product_name}</td>
//                                         <td style={{ padding: '6px', borderBottom: '1px solid #eee' }}>{item.thickness}</td>
//                                         <td style={{ padding: '6px', borderBottom: '1px solid #eee' }}>{item.grade}</td>
//                                         <td style={{ padding: '6px', borderBottom: '1px solid #eee' }}>{item.size}</td>
//                                         <td style={{ padding: '6px', borderBottom: '1px solid #eee' }}>{item.quantity}</td>
//                                         <td style={{ padding: '6px', borderBottom: '1px solid #eee' }}>₹{item.unit_price}</td>
//                                         <td style={{ padding: '6px', borderBottom: '1px solid #eee' }}>₹{(item.quantity * item.unit_price).toFixed(2)}</td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>

//                         {/* Modal Buttons */}
//                         <div style={{ textAlign: 'right', marginTop: '20px' }}>
//                             <button onClick={handlePrintPDF} style={{ background: '#28a745', color: '#fff', border: 'none', padding: '8px 15px', borderRadius: '5px', marginRight: '10px', cursor: 'pointer' }}>Print PDF</button>
//                             <button onClick={() => setSelectedOrder(null)} style={{ background: '#dc3545', color: '#fff', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer' }}>Close</button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//         </div>
//     );
// };

// export default SalesOrderList;




// import React, { useState, useEffect } from 'react';
// import { Plus, Search, Filter, Eye, Edit, FileText, X } from 'lucide-react';

// // Sample Data
// const salesData = [
//   { id: 'SO-001', customer: 'Acme Corp', date: '2024-12-20', amount: '$12,500', items: 5, status: 'Completed', salesperson: 'John Doe' },
//   { id: 'SO-002', customer: 'TechStart Inc', date: '2024-12-21', amount: '$8,900', items: 3, status: 'Pending', salesperson: 'Jane Smith' },
//   { id: 'SO-003', customer: 'Global Inc', date: '2024-12-22', amount: '$15,200', items: 7, status: 'Completed', salesperson: 'Mike Johnson' },
//   { id: 'SO-004', customer: 'Digital Pro', date: '2024-12-23', amount: '$6,750', items: 4, status: 'Processing', salesperson: 'Sarah Williams' },
//   { id: 'SO-005', customer: 'Creative Agency', date: '2024-12-24', amount: '$22,100', items: 9, status: 'Completed', salesperson: 'Tom Brown' },
// ];

// // Color Palette Variables for consistent theme mapping
// const colors = {
//   background: '#f8fafc',
//   cardBg: '#ffffff',
//   mutedBg: '#f1f5f9',
//   border: '#e2e8f0',
//   textMain: '#0f172a',
//   textMuted: '#64748b',
//   primary: '#2563eb',
//   primaryHover: '#1d4ed8',
//   primaryForeground: '#ffffff',
//   greenBg: '#dcfce7',
//   greenText: '#15803d',
//   orangeBg: '#ffedd5',
//   orangeText: '#c2410c',
//   blueBg: '#dbeafe',
//   blueText: '#1d4ed8',
//   modalBackdrop: 'rgba(0, 0, 0, 0.5)'
// };

// // export function SalesListScreen({ onCreateNew }) {
// const SalesOrderList = ({onCreateNew}) => {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedSale, setSelectedSale] = useState(null);
//   const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);

//   // Track responsive screen sizing changes
//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const isMobile = windowWidth < 640;
//   const isTablet = windowWidth < 768;
//   const isLarge = windowWidth >= 1024;

//   // Filter functionality
//   const filteredSales = salesData.filter(sale => 
//     sale.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     sale.customer.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     sale.salesperson.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const getStatusStyles = (status) => {
//     switch(status) {
//       case 'Completed': 
//         return { backgroundColor: colors.greenBg, color: colors.greenText };
//       case 'Pending': 
//         return { backgroundColor: colors.orangeBg, color: colors.orangeText };
//       default: 
//         return { backgroundColor: colors.blueBg, color: colors.blueText };
//     }
//   };

//   // Base Style Configurations
//   const containerStyle = {
//     padding: isLarge ? '2rem' : '1rem',
//     display: 'flex',
//     flexDirection: 'column',
//     gap: isLarge ? '1.5rem' : '1rem',
//     fontFamily: 'system-ui, -apple-system, sans-serif',
//     backgroundColor: colors.background,
//     minHeight: '100vh',
//     boxSizing: 'border-box'
//   };

//   const cardStyle = {
//     backgroundColor: colors.cardBg,
//     border: `1px solid ${colors.border}`,
//     borderRadius: '0.75rem',
//     padding: '1rem',
//     boxSizing: 'border-box'
//   };

//   return (
//     <div style={containerStyle}>
//       {/* Header Section */}
//       <div style={{
//         display: 'flex',
//         flexDirection: isMobile ? 'column' : 'row',
//         alignItems: isMobile ? 'stretch' : 'center',
//         justifyContent: 'between',
//         justifyContent: 'space-between',
//         gap: '1rem'
//       }}>
//         <div>
//           <h1 style={{ color: colors.textMain, fontSize: '1.5rem', fontWeight: '700', margin: '0 0 0.5rem 0' }}>Sales Orders</h1>
//           <p style={{ color: colors.textMuted, fontSize: isLarge ? '1rem' : '0.875rem', margin: 0 }}>View and manage all sales orders</p>
//         </div>
//         <button 
//           onClick={onCreateNew} 
//           style={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             gap: '0.5rem',
//             padding: '0.5rem 1rem',
//             backgroundColor: colors.primary,
//             color: colors.primaryForeground,
//             borderRadius: '0.5rem',
//             border: 'none',
//             cursor: 'pointer',
//             fontSize: isLarge ? '1rem' : '0.875rem',
//             fontWeight: '500',
//             transition: 'background-color 0.2s',
//             width: isMobile ? '100%' : 'auto'
//           }}
//           onMouseEnter={(e) => e.currentTarget.style.backgroundColor = colors.primaryHover}
//           onMouseLeave={(e) => e.currentTarget.style.backgroundColor = colors.primary}
//         >
//           <Plus style={{ width: isLarge ? '1.25rem' : '1rem', height: isLarge ? '1.25rem' : '1rem' }} />
//           New Sales Order
//         </button>
//       </div>

//       {/* Stats Cards Dashboard */}
//       <div style={{
//         display: 'grid',
//         gridTemplateColumns: isMobile ? 'repeat(2, minmax(0, 1fr))' : 'repeat(4, minmax(0, 1fr))',
//         gap: '1rem'
//       }}>
//         <div style={cardStyle}>
//           <p style={{ color: colors.textMuted, fontSize: '0.875rem', margin: '0 0 0.25rem 0' }}>Total Orders</p>
//           <h3 style={{ color: colors.textMain, fontSize: '1.25rem', fontWeight: '700', margin: 0 }}>342</h3>
//         </div>
//         <div style={cardStyle}>
//           <p style={{ color: colors.textMuted, fontSize: '0.875rem', margin: '0 0 0.25rem 0' }}>Pending</p>
//           <h3 style={{ color: colors.orangeText, fontSize: '1.25rem', fontWeight: '700', margin: 0 }}>45</h3>
//         </div>
//         <div style={cardStyle}>
//           <p style={{ color: colors.textMuted, fontSize: '0.875rem', margin: '0 0 0.25rem 0' }}>Completed</p>
//           <h3 style={{ color: colors.greenText, fontSize: '1.25rem', fontWeight: '700', margin: 0 }}>287</h3>
//         </div>
//         <div style={cardStyle}>
//           <p style={{ color: colors.textMuted, fontSize: '0.875rem', margin: '0 0 0.25rem 0' }}>Total Value</p>
//           <h3 style={{ color: colors.textMain, fontSize: '1.25rem', fontWeight: '700', margin: 0 }}>$1.2M</h3>
//         </div>
//       </div>

//       {/* Search and Filters Section */}
//       <div style={cardStyle}>
//         <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: '1rem' }}>
//           <div style={{ flex: 1, position: 'relative', display: 'flex', alignItems: 'center' }}>
//             <Search style={{ position: 'absolute', left: '0.75rem', width: '1.25rem', height: '1.25rem', color: colors.textMuted, pointerEvents: 'none' }} />
//             <input
//               type="text"
//               placeholder="Search sales orders..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               style={{
//                 width: '100%',
//                 padding: '0.5rem 1rem 0.5rem 2.5rem',
//                 backgroundColor: colors.mutedBg,
//                 borderRadius: '0.5rem',
//                 border: '1px solid transparent',
//                 outline: 'none',
//                 boxSizing: 'border-box',
//                 fontSize: '0.875rem',
//                 color: colors.textMain
//               }}
//               onFocus={(e) => e.currentTarget.style.borderColor = colors.primary}
//               onBlur={(e) => e.currentTarget.style.borderColor = 'transparent'}
//             />
//           </div>
//           <button style={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             gap: '0.5rem',
//             padding: '0.5rem 1rem',
//             backgroundColor: colors.mutedBg,
//             color: colors.textMain,
//             borderRadius: '0.5rem',
//             border: 'none',
//             cursor: 'pointer',
//             fontSize: '0.875rem',
//             fontWeight: '500'
//           }}>
//             <Filter style={{ width: '1.25rem', height: '1.25rem' }} />
//             Filter
//           </button>
//         </div>
//       </div>

//       {/* Main Table / Container Card */}
//       <div style={{ ...cardStyle, padding: isLarge ? '1.5rem' : '1rem' }}>
        
//         {/* DESKTOP VIEW: Table Structure */}
//         {!isTablet && (
//           <div style={{ overflowX: 'auto' }}>
//             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//               <thead>
//                 <tr style={{ borderBottom: `1px solid ${colors.border}` }}>
//                   {['Order ID', 'Customer', 'Date', 'Items', 'Amount', 'Salesperson', 'Status', 'Actions'].map((header, idx) => (
//                     <th key={idx} style={{
//                       textAlign: header === 'Actions' ? 'right' : 'left',
//                       padding: '0.75rem 1rem',
//                       color: colors.textMuted,
//                       fontSize: '0.875rem',
//                       fontWeight: '500'
//                     }}>{header}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredSales.map((sale) => (
//                   <tr key={sale.id} style={{ borderBottom: `1px solid ${colors.border}`, transition: 'background-color 0.2s' }}>
//                     <td style={{ padding: '1rem', color: colors.textMain, fontWeight: '500' }}>{sale.id}</td>
//                     <td style={{ padding: '1rem', color: colors.textMain }}>{sale.customer}</td>
//                     <td style={{ padding: '1rem', color: colors.textMuted, fontSize: '0.875rem' }}>{sale.date}</td>
//                     <td style={{ padding: '1rem', color: colors.textMain }}>{sale.items}</td>
//                     <td style={{ padding: '1rem', color: colors.textMain, fontWeight: '500' }}>{sale.amount}</td>
//                     <td style={{ padding: '1rem', color: colors.textMain }}>{sale.salesperson}</td>
//                     <td style={{ padding: '1rem' }}>
//                       <span style={{
//                         padding: '0.25rem 0.75rem',
//                         borderRadius: '9999px',
//                         fontSize: '0.75rem',
//                         fontWeight: '500',
//                         ...getStatusStyles(sale.status)
//                       }}>
//                         {sale.status}
//                       </span>
//                     </td>
//                     <td style={{ padding: '1rem' }}>
//                       <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
//                         <button onClick={() => setSelectedSale(sale)} style={{ padding: '0.5rem', background: 'none', border: 'none', cursor: 'pointer', borderRadius: '0.375rem' }} title="View details">
//                           <Eye style={{ width: '1rem', height: '1rem', color: colors.textMain }} />
//                         </button>
//                         <button style={{ padding: '0.5rem', background: 'none', border: 'none', cursor: 'pointer', borderRadius: '0.375rem' }}>
//                           <Edit style={{ width: '1rem', height: '1rem', color: colors.textMain }} />
//                         </button>
//                         <button style={{ padding: '0.5rem', background: 'none', border: 'none', cursor: 'pointer', borderRadius: '0.375rem' }}>
//                           <FileText style={{ width: '1rem', height: '1rem', color: colors.textMain }} />
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}

//         {/* MOBILE VIEW: Grid Blocks */}
//         {isTablet && (
//           <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
//             {filteredSales.map((sale) => (
//               <div key={sale.id} style={{
//                 border: `1px solid ${colors.border}`,
//                 borderRadius: '0.5rem',
//                 padding: '1rem',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 gap: '0.75rem',
//                 backgroundColor: 'rgba(241, 245, 249, 0.2)'
//               }}>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: `1px solid ${colors.border}`, paddingBottom: '0.5rem' }}>
//                   <div>
//                     <span style={{ fontSize: '0.875rem', fontWeight: '700', color: colors.textMain, display: 'block' }}>{sale.id}</span>
//                     <span style={{ fontSize: '0.75rem', color: colors.textMuted }}>{sale.date}</span>
//                   </div>
//                   <span style={{
//                     padding: '0.125rem 0.625rem',
//                     borderRadius: '9999px',
//                     fontSize: '0.75rem',
//                     fontWeight: '500',
//                     ...getStatusStyles(sale.status)
//                   }}>
//                     {sale.status}
//                   </span>
//                 </div>
                
//                 <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '0.5rem', fontSize: '0.875rem' }}>
//                   <div>
//                     <p style={{ fontSize: '0.75rem', color: colors.textMuted, margin: 0 }}>Customer</p>
//                     <p style={{ color: colors.textMain, fontWeight: '500', margin: 0 }}>{sale.customer}</p>
//                   </div>
//                   <div>
//                     <p style={{ fontSize: '0.75rem', color: colors.textMuted, margin: 0 }}>Amount</p>
//                     <p style={{ color: colors.textMain, fontWeight: '700', margin: 0 }}>{sale.amount}</p>
//                   </div>
//                   <div>
//                     <p style={{ fontSize: '0.75rem', color: colors.textMuted, margin: 0 }}>Items</p>
//                     <p style={{ color: colors.textMain, margin: 0 }}>{sale.items} items</p>
//                   </div>
//                   <div>
//                     <p style={{ fontSize: '0.75rem', color: colors.textMuted, margin: 0 }}>Sales Rep</p>
//                     <p style={{ color: colors.textMain, fontSize: '0.75rem', margin: 0 }}>{sale.salesperson}</p>
//                   </div>
//                 </div>

//                 <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem', paddingTop: '0.5rem', borderTop: `1px solid ${colors.border}` }}>
//                   <button onClick={() => setSelectedSale(sale)} style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', padding: '0.375rem 0.75rem', backgroundColor: colors.mutedBg, border: 'none', borderRadius: '0.375rem', fontSize: '0.75rem', fontWeight: '500', color: colors.textMain, cursor: 'pointer' }}>
//                     <Eye style={{ width: '0.875rem', height: '0.875rem' }} /> View
//                   </button>
//                   <button style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', padding: '0.375rem 0.75rem', backgroundColor: colors.mutedBg, border: 'none', borderRadius: '0.375rem', fontSize: '0.75rem', fontWeight: '500', color: colors.textMain, cursor: 'pointer' }}>
//                     <Edit style={{ width: '0.875rem', height: '0.875rem' }} /> Edit
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}

//         {/* Empty State Fallback */}
//         {filteredSales.length === 0 && (
//           <p style={{ textAlign: 'center', color: colors.textMuted, padding: '1.5rem 0', margin: 0 }}>No matching orders found.</p>
//         )}
//       </div>

//       {/* VIEW DETAILS MODAL CONTAINER */}
//       {selectedSale && (
//         <div style={{
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           right: 0,
//           bottom: 0,
//           zIndex: 50,
//           backgroundColor: colors.modalBackdrop,
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           padding: '1rem',
//           backdropFilter: 'blur(4px)'
//         }}>
//           <div style={{
//             backgroundColor: colors.cardBg,
//             border: `1px solid ${colors.border}`,
//             borderRadius: '0.75rem',
//             width: '100%',
//             maxWidth: '28rem',
//             padding: '1.5rem',
//             position: 'relative',
//             boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
//           }}>
//             <button 
//               onClick={() => setSelectedSale(null)}
//               style={{
//                 position: 'absolute',
//                 right: '1rem',
//                 top: '1rem',
//                 padding: '0.25rem',
//                 background: 'none',
//                 border: 'none',
//                 cursor: 'pointer',
//                 color: colors.textMuted
//               }}
//             >
//               <X style={{ width: '1.25rem', height: '1.25rem' }} />
//             </button>
            
//             <h2 style={{ fontSize: '1.125rem', fontWeight: '700', color: colors.textMain, margin: '0 0 1rem 0' }}>Order Details</h2>
            
//             <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
//               {[
//                 { label: 'Order ID', val: selectedSale.id, mono: true, bold: true },
//                 { label: 'Customer', val: selectedSale.customer, bold: true },
//                 { label: 'Date', val: selectedSale.date },
//                 { label: 'Items Ordered', val: selectedSale.items },
//                 { label: 'Total Amount', val: selectedSale.amount, bold: true, highlight: true },
//                 { label: 'Salesperson', val: selectedSale.salesperson }
//               ].map((item, index) => (
//                 <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: `1px solid ${colors.border}`, paddingBottom: '0.5rem' }}>
//                   <span style={{ color: colors.textMuted, fontSize: '0.875rem' }}>{item.label}</span>
//                   <span style={{
//                     color: colors.textMain,
//                     fontFamily: item.mono ? 'monospace' : 'inherit',
//                     fontWeight: item.bold ? '700' : '400',
//                     fontSize: item.highlight ? '1.125rem' : '0.875rem'
//                   }}>{item.val}</span>
//                 </div>
//               ))}
              
//               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '0.5rem' }}>
//                 <span style={{ color: colors.textMuted, fontSize: '0.875rem' }}>Order Status</span>
//                 <span style={{
//                   padding: '0.25rem 0.75rem',
//                   borderRadius: '9999px',
//                   fontSize: '0.75rem',
//                   fontWeight: '500',
//                   ...getStatusStyles(selectedSale.status)
//                 }}>
//                   {selectedSale.status}
//                 </span>
//               </div>
//             </div>

//             <button 
//               onClick={() => setSelectedSale(null)}
//               style={{
//                 marginTop: '1.5rem',
//                 width: '100%',
//                 padding: '0.5rem 0',
//                 backgroundColor: colors.mutedBg,
//                 color: colors.textMain,
//                 border: 'none',
//                 borderRadius: '0.5rem',
//                 fontSize: '0.875rem',
//                 fontWeight: '500',
//                 cursor: 'pointer'
//               }}
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default SalesOrderList;


import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { useNavigate } from 'react-router-dom';
import { Plus, Search, Filter, Eye, Edit, Trash2, FileText, X } from 'lucide-react';

const SalesOrderList = () => {
    // Keep exact original functionality states
    const [salesOrders, setSalesOrders] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState(''); // Added to connect the search bar functionality
    const ordersPerPage = 10;
    const orderRef = useRef();
    const navigate = useNavigate();

    // Track responsive viewport state for pure inline styling rules
    const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isMobile = windowWidth < 640;
    const isTablet = windowWidth < 768;
    const isLarge = windowWidth >= 1024;

    // ✅ Get logged-in user info
    const storedUser = JSON.parse(sessionStorage.getItem("userData"));
    const loggedInUserId = storedUser?.id;
    console.log("Logged User:", storedUser);

    useEffect(() => {
        fetchOrders();
    }, []);

    const fetchOrders = async () => {
        try {
            const res = await axios.get("https://cloudapi.emedhatechnologies.com/pages/api/api/sales-orders");
            const filteredOrders = res.data
                .map(order => ({ ...order, items: typeof order.items === "string" ? JSON.parse(order.items || "[]") : order.items || [], }))
                .filter(order => String(order.user_id) === String(loggedInUserId));
            setSalesOrders(filteredOrders);
        } catch (err) {
            console.error("Error fetching sales orders:", err);
            alert("Failed to load sales orders");
        }
    };
                                                        
    const handlePrintPDF = async () => {
        if (!orderRef.current) return;
        const canvas = await html2canvas(orderRef.current, { scale: 2 });
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const width = pdf.internal.pageSize.getWidth();
        const height = (canvas.height * width) / canvas.width;
        pdf.addImage(imgData, "PNG", 0, 0, width, height);
        pdf.save(`SalesOrder_${selectedOrder.order_number}.pdf`);
    };

    const handleEditOrder = (orderId) => navigate(`/dashboard/orders/edit/${orderId}`);

    const handleDeleteOrder = async (orderId) => {
        if (!window.confirm("Are you sure you want to delete this order?")) return;
        try {
            await axios.delete(`https://cloudapi.emedhatechnologies.com/pages/api/api/sales-orders/${orderId}`);
            alert("🗑️ Order deleted successfully!");
            fetchOrders();
        } catch (err) {
            console.error("Error deleting order:", err);
            alert("❌ Failed to delete order");
        }
    };

    // Original processing calculations with filter capabilities injected seamlessly
    const filteredSales = salesOrders.filter(sale => 
        (sale.order_number || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (sale.customer_name || '').toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Pagination logic applied to filtered sales
    const indexOfLastOrder = currentPage * ordersPerPage;
    const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
    const currentOrders = filteredSales.slice(indexOfFirstOrder, indexOfLastOrder);
    const totalPages = Math.ceil(filteredSales.length / ordersPerPage);

    // High-fidelity style tokens matching the previous design structure
    const colors = {
        background: '#f8fafc',
        cardBg: '#ffffff',
        mutedBg: '#f1f5f9',
        border: '#e2e8f0',
        textMain: '#0f172a',
        textMuted: '#64748b',
        primary: '#2563eb',
        primaryHover: '#1d4ed8',
        primaryForeground: '#ffffff',
        greenText: '#15803d',
        dangerText: '#dc2626',
        modalBackdrop: 'rgba(0, 0, 0, 0.5)'
    };

    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        gap: isLarge ? '1.5rem' : '1rem',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        backgroundColor: colors.background,
        minHeight: '100vh',
        boxSizing: 'border-box',
        width: '100%'
    };

    const cardStyle = {
        backgroundColor: colors.cardBg,
        border: `1px solid ${colors.border}`,
        borderRadius: '0.75rem',
        padding: '1rem',
        boxSizing: 'border-box'
    };

    return (
        <div style={containerStyle}>
            {/* Header Area */}
            <div style={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                alignItems: isMobile ? 'stretch' : 'center',
                justifyContent: 'space-between',
                gap: '1rem'
            }}>
                <div>
                    <h1 style={{ color: colors.textMain, fontSize: '1.5rem', fontWeight: '700', margin: '0 0 0.25rem 0' }}>My Sales Orders</h1>
                    <p style={{ color: colors.textMuted, fontSize: isLarge ? '1rem' : '0.875rem', margin: 0 }}>View and manage all your verified cloud sales metrics</p>
                </div>
                <button 
                    onClick={() => navigate('/dashboard/orders')} // Fallback redirect if you decide to have a creation point
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '0.5rem',
                        padding: '0.5rem 1rem',
                        backgroundColor: colors.primary,
                        color: colors.primaryForeground,
                        borderRadius: '0.5rem',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: isLarge ? '1rem' : '0.875rem',
                        fontWeight: '500',
                        width: isMobile ? '100%' : 'auto'
                    }}
                >
                    <Plus style={{ width: '1.25rem', height: '1.25rem' }} />
                    Create New Order
                </button>
            </div>

            {/* Dynamic Metric Counter Displays */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, minmax(0, 1fr))',
                gap: '1rem'
            }}>
                <div style={cardStyle}>
                    <p style={{ color: colors.textMuted, fontSize: '0.875rem', margin: '0 0 0.25rem 0' }}>Total Streamed Records</p>
                    <h3 style={{ color: colors.textMain, fontSize: '1.5rem', fontWeight: '700', margin: 0 }}>{salesOrders.length}</h3>
                </div>
                <div style={cardStyle}>
                    <p style={{ color: colors.textMuted, fontSize: '0.875rem', margin: '0 0 0.25rem 0' }}>Current Page Scope</p>
                    <h3 style={{ color: colors.primary, fontSize: '1.5rem', fontWeight: '700', margin: 0 }}>{currentOrders.length} Orders</h3>
                </div>
                <div style={cardStyle}>
                    <p style={{ color: colors.textMuted, fontSize: '0.875rem', margin: '0 0 0.25rem 0' }}>Gross Valuation (This Page)</p>
                    <h3 style={{ color: colors.greenText, fontSize: '1.5rem', fontWeight: '700', margin: 0 }}>
                        ₹{currentOrders.reduce((sum, order) => sum + order.items.reduce((s, it) => s + (it.quantity * it.unit_price), 0), 0).toFixed(2)}
                    </h3>
                </div>
            </div>

            {/* Interactive Filters Panel */}
            <div style={cardStyle}>
                <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: '1rem' }}>
                    <div style={{ flex: 1, position: 'relative', display: 'flex', alignItems: 'center' }}>
                        <Search style={{ position: 'absolute', left: '0.75rem', width: '1.25rem', height: '1.25rem', color: colors.textMuted, pointerEvents: 'none' }} />
                        <input
                            type="text"
                            placeholder="Search orders by number or customer name..."
                            value={searchTerm}
                            onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
                            style={{
                                width: '100%',
                                padding: '0.5rem 1rem 0.5rem 2.5rem',
                                backgroundColor: colors.mutedBg,
                                borderRadius: '0.5rem',
                                border: '1px solid transparent',
                                outline: 'none',
                                boxSizing: 'border-box',
                                fontSize: '0.875rem',
                                color: colors.textMain
                            }}
                        />
                    </div>
                    <button style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '0.5rem',
                        padding: '0.5rem 1rem',
                        backgroundColor: colors.mutedBg,
                        color: colors.textMain,
                        borderRadius: '0.5rem',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '0.875rem',
                        fontWeight: '500'
                    }}>
                        <Filter style={{ width: '1.25rem', height: '1.25rem' }} />
                        Filter
                    </button>
                </div>
            </div>

            {/* Core Data Structure Block */}
            <div style={{ ...cardStyle, padding: isLarge ? '1.5rem' : '1rem' }}>
                
                {/* DESKTOP MATRIX: Renders table on screens above breaking tablet width limits */}
                {!isTablet && (
                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr style={{ borderBottom: `1px solid ${colors.border}` }}>
                                    {['Order #', 'Customer', 'Order Date', 'Total Amount', 'Actions'].map((header, idx) => (
                                        <th key={idx} style={{
                                            textAlign: header === 'Actions' ? 'right' : 'left',
                                            padding: '0.75rem 1rem',
                                            color: colors.textMuted,
                                            fontSize: '0.875rem',
                                            fontWeight: '500'
                                        }}>{header}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {currentOrders.length > 0 ? currentOrders.map((order) => {
                                    const total = order.items.reduce((sum, it) => sum + (it.quantity * it.unit_price), 0);
                                    return (
                                        <tr key={order.id} style={{ borderBottom: `1px solid ${colors.border}`, transition: 'background-color 0.2s' }}>
                                            <td style={{ padding: '1rem', color: colors.textMain, fontWeight: '600' }}>{order.order_number}</td>
                                            <td style={{ padding: '1rem', color: colors.textMain }}>{order.customer_name}</td>
                                            <td style={{ padding: '1rem', color: colors.textMuted, fontSize: '0.875rem' }}>{new Date(order.order_date).toLocaleDateString()}</td>
                                            <td style={{ padding: '1rem', color: colors.textMain, fontWeight: '600' }}>₹{total.toFixed(2)}</td>
                                            <td style={{ padding: '1rem' }}>
                                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                                                    <button onClick={() => setSelectedOrder(order)} style={{ padding: '0.5rem', background: 'none', border: 'none', cursor: 'pointer' }} title="View details">
                                                        <Eye style={{ width: '1.1rem', height: '1.1rem', color: colors.primary }} />
                                                    </button>
                                                    <button onClick={() => handleEditOrder(order.id)} style={{ padding: '0.5rem', background: 'none', border: 'none', cursor: 'pointer' }} title="Edit details">
                                                        <Edit style={{ width: '1.1rem', height: '1.1rem', color: colors.greenText }} />
                                                    </button>
                                                    <button onClick={() => handleDeleteOrder(order.id)} style={{ padding: '0.5rem', background: 'none', border: 'none', cursor: 'pointer' }} title="Remove detail">
                                                        <Trash2 style={{ width: '1.1rem', height: '1.1rem', color: colors.dangerText }} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                }) : (
                                    <tr>
                                        <td colSpan="5" style={{ textAlign: 'center', padding: '2rem', color: colors.textMuted }}>No sales orders found for this user</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}

                {/* MOBILE DESIGN BLOCKS: Activated dynamically when screens decrease into mobile viewports */}
                {isTablet && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        {currentOrders.length > 0 ? currentOrders.map((order) => {
                            const total = order.items.reduce((sum, it) => sum + (it.quantity * it.unit_price), 0);
                            return (
                                <div key={order.id} style={{
                                    border: `1px solid ${colors.border}`,
                                    borderRadius: '0.5rem',
                                    padding: '1rem',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '0.75rem',
                                    backgroundColor: 'rgba(241, 245, 249, 0.2)'
                                }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: `1px solid ${colors.border}`, paddingBottom: '0.5rem' }}>
                                        <div>
                                            <span style={{ fontSize: '0.875rem', fontWeight: '700', color: colors.textMain, display: 'block' }}>{order.order_number}</span>
                                            <span style={{ fontSize: '0.75rem', color: colors.textMuted }}>{new Date(order.order_date).toLocaleDateString()}</span>
                                        </div>
                                        <span style={{ fontSize: '1rem', fontWeight: '700', color: colors.textMain }}>₹{total.toFixed(2)}</span>
                                    </div>
                                    
                                    <div style={{ fontSize: '0.875rem' }}>
                                        <p style={{ fontSize: '0.75rem', color: colors.textMuted, margin: 0 }}>Customer Name</p>
                                        <p style={{ color: colors.textMain, fontWeight: '500', margin: 0 }}>{order.customer_name}</p>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem', paddingTop: '0.5rem', borderTop: `1px solid ${colors.border}` }}>
                                        <button onClick={() => setSelectedOrder(order)} style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', padding: '0.375rem 0.75rem', backgroundColor: colors.mutedBg, border: 'none', borderRadius: '0.375rem', fontSize: '0.75rem', fontWeight: '500', color: colors.textMain, cursor: 'pointer' }}>
                                            <Eye style={{ width: '0.875rem', height: '0.875rem', color: colors.primary }} /> View
                                        </button>
                                        <button onClick={() => handleEditOrder(order.id)} style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', padding: '0.375rem 0.75rem', backgroundColor: colors.mutedBg, border: 'none', borderRadius: '0.375rem', fontSize: '0.75rem', fontWeight: '500', color: colors.textMain, cursor: 'pointer' }}>
                                            <Edit style={{ width: '0.875rem', height: '0.875rem', color: colors.greenText }} /> Edit
                                        </button>
                                        <button onClick={() => handleDeleteOrder(order.id)} style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', padding: '0.375rem 0.75rem', backgroundColor: colors.mutedBg, border: 'none', borderRadius: '0.375rem', fontSize: '0.75rem', fontWeight: '500', color: colors.textMain, cursor: 'pointer' }}>
                                            <Trash2 style={{ width: '0.875rem', height: '0.875rem', color: colors.dangerText }} /> Delete
                                        </button>
                                    </div>
                                </div>
                            );
                        }) : (
                            <p style={{ textAlign: 'center', color: colors.textMuted, padding: '1rem 0', margin: 0 }}>No sales orders found for this user</p>
                        )}
                    </div>
                )}

                {/* Modern Pagination Navigation Interface */}
                {totalPages > 0 && (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1rem', marginTop: '1.5rem', paddingTop: '1rem', borderTop: `1px solid ${colors.border}` }}>
                        <button 
                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} 
                            disabled={currentPage === 1} 
                            style={{ 
                                padding: '0.5rem 1rem', 
                                border: `1px solid ${colors.border}`, 
                                borderRadius: '0.375rem', 
                                backgroundColor: currentPage > 1 ? colors.cardBg : colors.mutedBg, 
                                color: currentPage > 1 ? colors.textMain : colors.textMuted, 
                                cursor: currentPage > 1 ? 'pointer' : 'not-allowed',
                                fontSize: '0.875rem',
                                fontWeight: '500'
                            }}
                        >
                            Previous
                        </button>
                        <span style={{ fontSize: '0.875rem', color: colors.textMain, fontWeight: '500' }}>
                            Page {currentPage} of {totalPages || 1}
                        </span>
                        <button 
                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} 
                            disabled={currentPage === totalPages || totalPages === 0} 
                            style={{ 
                                padding: '0.5rem 1rem', 
                                border: `1px solid ${colors.border}`, 
                                borderRadius: '0.375rem', 
                                backgroundColor: currentPage < totalPages ? colors.cardBg : colors.mutedBg, 
                                color: currentPage < totalPages ? colors.textMain : colors.textMuted, 
                                cursor: currentPage < totalPages ? 'pointer' : 'not-allowed',
                                fontSize: '0.875rem',
                                fontWeight: '500'
                            }}
                        >
                            Next
                        </button>
                    </div>
                )}
            </div>

            {/* DETAILED ORDER DOCUMENTATION MODAL POPUP */}
            {selectedOrder && (
                <div style={{
                    position: 'fixed',
                    top: 0, left: 0, right: 0, bottom: 0,
                    zIndex: 1000,
                    backgroundColor: colors.modalBackdrop,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '1rem',
                    backdropFilter: 'blur(4px)'
                }}>
                    <div ref={orderRef} style={{
                        backgroundColor: colors.cardBg,
                        border: `1px solid ${colors.border}`,
                        borderRadius: '0.75rem',
                        width: '100%',
                        maxWidth: '800px',
                        maxHeight: '90vh',
                        overflowY: 'auto',
                        padding: isLarge ? '2rem' : '1.25rem',
                        position: 'relative',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
                        boxSizing: 'border-box'
                    }}>
                        {/* Close Modal Cross Icon Button */}
                        <button 
                            onClick={() => setSelectedOrder(null)}
                            style={{ position: 'absolute', right: '1.25rem', top: '1.25rem', padding: '0.25rem', background: 'none', border: 'none', cursor: 'pointer', color: colors.textMuted }}
                        >
                          <X style={{ width: '1.5rem', height: '1.5rem' }} />
                        </button>
                        
                        <h3 style={{ fontSize: '1.25rem', fontWeight: '700', color: colors.textMain, borderBottom: `2px solid ${colors.primary}`, paddingBottom: '0.75rem', marginBottom: '1.5rem', marginTop: 0 }}>
                            🧾 Order Document #{selectedOrder.order_number}
                        </h3>

                        {/* Document Infrastructure Fields */}
                        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)', gap: '0.75rem', marginBottom: '1.5rem' }}>
                            {[
                                { key: "Customer", val: selectedOrder.customer_name },
                                { key: "Order Date", val: new Date(selectedOrder.order_date).toLocaleDateString() },
                                { key: "GST", val: selectedOrder.gst },
                                { key: "GST Amount", val: `₹${selectedOrder.gst_amount?.toFixed(2) || 0}` },
                                { key: "Discount Applied", val: `₹${selectedOrder.discount?.toFixed(2) || 0}` },
                                { key: "Grand Total Sum", val: `₹${selectedOrder.total_amount?.toFixed(2) || 0}`, highlight: true }
                            ].map((info, itemIdx) => (
                                <div key={itemIdx} style={{ backgroundColor: colors.mutedBg, padding: '0.75rem', borderRadius: '0.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <strong style={{ fontSize: '0.875rem', color: colors.textMuted }}>{info.key}:</strong>
                                    <span style={{ fontSize: '0.875rem', color: info.highlight ? colors.greenText : colors.textMain, fontWeight: info.highlight || typeof info.val === 'string' && info.val.startsWith('₹') ? '700' : '500' }}>{info.val}</span>
                                </div>
                            ))}
                        </div>

                        {/* Extra Logistical Information Boxes */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginBottom: '1.5rem' }}>
                            <div style={{ backgroundColor: colors.mutedBg, padding: '0.75rem', borderRadius: '0.5rem', fontSize: '0.875rem' }}>
                                <strong style={{ color: colors.textMuted, display: 'block', marginBottom: '0.25rem' }}>Shipping Logistics Address:</strong>
                                <span style={{ color: colors.textMain, fontWeight: '500' }}>{selectedOrder.shipping_address || 'N/A'}</span>
                            </div>
                            <div style={{ backgroundColor: colors.mutedBg, padding: '0.75rem', borderRadius: '0.5rem', fontSize: '0.875rem' }}>
                                <strong style={{ color: colors.textMuted, display: 'block', marginBottom: '0.25rem' }}>Document Internal Notes:</strong>
                                <span style={{ color: colors.textMain, fontWeight: '500' }}>{selectedOrder.notes || 'N/A'}</span>
                            </div>
                        </div>

                        {/* Itemized Specification Grid */}
                        <div style={{ overflowX: 'auto', marginBottom: '1.5rem', border: `1px solid ${colors.border}`, borderRadius: '0.5rem' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '600px' }}>
                                <thead>
                                    <tr style={{ backgroundColor: colors.mutedBg, borderBottom: `1px solid ${colors.border}` }}>
                                        {['Product', 'Thickness', 'Grade', 'Size', 'Qty', 'Unit Price', 'Total'].map((th, i) => (
                                            <th key={i} style={{ padding: '0.75rem', textAlign: 'left', fontSize: '0.875rem', color: colors.textMuted, fontWeight: '600' }}>{th}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedOrder.items.map((item, idx) => (
                                        <tr key={idx} style={{ borderBottom: idx !== selectedOrder.items.length - 1 ? `1px solid ${colors.border}` : 'none' }}>
                                            <td style={{ padding: '0.75rem', fontSize: '0.875rem', color: colors.textMain, fontWeight: '500' }}>{item.product_name}</td>
                                            <td style={{ padding: '0.75rem', fontSize: '0.875rem', color: colors.textMain }}>{item.thickness}</td>
                                            <td style={{ padding: '0.75rem', fontSize: '0.875rem', color: colors.textMain }}>{item.grade}</td>
                                            <td style={{ padding: '0.75rem', fontSize: '0.875rem', color: colors.textMain }}>{item.size}</td>
                                            <td style={{ padding: '0.75rem', fontSize: '0.875rem', color: colors.textMain }}>{item.quantity}</td>
                                            <td style={{ padding: '0.75rem', fontSize: '0.875rem', color: colors.textMain }}>₹{item.unit_price}</td>
                                            <td style={{ padding: '0.75rem', fontSize: '0.875rem', color: colors.textMain, fontWeight: '600' }}>₹{(item.quantity * item.unit_price).toFixed(2)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Interactive Modal Action Toolbar */}
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.75rem', borderTop: `1px solid ${colors.border}`, paddingTop: '1rem' }}>
                            <button 
                                onClick={handlePrintPDF} 
                                style={{ 
                                    display: 'flex', alignItems: 'center', gap: '0.5rem',
                                    backgroundColor: colors.primary, color: colors.primaryForeground, 
                                    border: 'none', padding: '0.5rem 1.25rem', borderRadius: '0.5rem', 
                                    fontWeight: '500', fontSize: '0.875rem', cursor: 'pointer' 
                                }}
                            >
                                <FileText style={{ width: '1rem', height: '1rem' }} /> Print PDF Document
                            </button>
                            <button 
                                onClick={() => setSelectedOrder(null)} 
                                style={{ 
                                    backgroundColor: colors.mutedBg, color: colors.textMain, 
                                    border: 'none', padding: '0.5rem 1.25rem', borderRadius: '0.5rem', 
                                    fontWeight: '500', fontSize: '0.875rem', cursor: 'pointer' 
                                }}
                            >
                                Close View
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SalesOrderList;